const PolygonPath = (points: Point[]) => {
  const commands = []

  const start = points.shift()

  if (!start) {
    throw new Error("Polygon points are empty")
  }

  commands.push("M" + start.x + "," + start.y)

  for (const coord of points) {
    commands.push("L" + coord.x + "," + coord.y)
  }

  commands.push("Z")

  return commands.join(" ")
}

export default PolygonPath
